'use client';

const Loader = ({ message = "Loading...", subtitle = "Please wait" }) => {
    return (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-white/85 backdrop-blur-md transition-all">
            <div className="flex flex-col items-center gap-4 p-8 rounded-2xl">
                {/* Brand Spinner Container */}
                <div className="relative w-16 h-16 flex items-center justify-center">
                    {/* Outer Smooth Rotating Ring */}
                    <div className="absolute inset-0 rounded-full border-[3.5px] border-slate-100 border-t-[#810A5F] border-r-[#A61382] animate-spin" />

                    {/* Subtle Pulse Halo */}
                    <div className="absolute inset-2 rounded-full bg-[#810A5F]/10 animate-ping opacity-60" />

                    {/* Centered Brand House Icon */}
                    <div className="relative z-10 w-8 h-8 rounded-lg bg-gradient-to-br from-[#810A5F] to-[#5D0745] flex items-center justify-center text-white shadow-md">
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2.2}
                                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                            />
                        </svg>
                    </div>
                </div>

                {/* Brand Text & Indicator */}
                <div className="flex flex-col items-center gap-1 text-center">
                    <span className="text-base font-bold tracking-tight bg-gradient-to-r from-[#810A5F] to-[#A61382] bg-clip-text text-transparent">
                        DreamAcres
                    </span>
                    <div className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
                        <span>{message}</span>
                        <span className="inline-flex items-center gap-0.5">
                            <span className="w-1 h-1 rounded-full bg-[#810A5F] animate-bounce [animation-delay:-0.3s]" />
                            <span className="w-1 h-1 rounded-full bg-[#810A5F] animate-bounce [animation-delay:-0.15s]" />
                            <span className="w-1 h-1 rounded-full bg-[#810A5F] animate-bounce" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Loader;
